export enum TransactionType {
  BUY = 'BUY',
  SELL = 'SELL',
  TOPUP_CREDIT = 'TOPUP_CREDIT',
  WITHDRAW_CREDIT = 'WITHDRAW_CREDIT',
  DEPOSIT = 'DEPOSIT',
  REDEEM = 'REDEEM',
  DEPOSIT_STOCK = 'DEPOSIT_STOCK',
  REDEEM_STOCK = 'REDEEM_STOCK',
  CREDIT_LOAN = 'CREDIT_LOAN',
  PAY_CREDIT_LOAN = 'PAY_CREDIT_LOAN',
  TOPUP_DEPOSIT = 'TOPUP_DEPOSIT',

  BUY_POSITION = 'BUY_POSITION', // ตัดซื้อ
  SELL_POSITION = 'SELL_POSITION', // ตัดขาย
}

export type TransactionBadgeType = {
  total: number;
  waiting: number;
  waitingPayment?: number;
  waitingTicket?: number;
  pending: number;
  success: number;
  rejected: number;
  cancel: number;
  failed: number;
};

export enum TransactionStatus {
  WAITING = 'WAITING', // รอราคา
  WAITING_TICKET = 'WAITING_TICKET', // รอเลือกตั๋วทอง [sell-position, redeem]
  WAITING_PAYMENT = 'WAITING_PAYMENT', // รอชำระเงิน [buy-position]
  PENDING = 'PENDING', // รออนุมัติ
  SUCCESS = 'SUCCESS', // เสร็จสิ้น / สำเร็จ
  REJECTED = 'REJECTED', // ปฏิเสธ
  CANCEL = 'CANCEL', // ยกเลิก
  FAILED = 'FAILED', // ล้มเหลว
}

export type RtTransactionBadgeType = {
  REDEEM: {
    PENDING: number;
    updatedAt: number;
  };
  TOPUP_CREDIT: {
    PENDING: number;
    updatedAt: number;
  };
  WITHDRAW_CREDIT: {
    PENDING: number;
    updatedAt: number;
  };
  BUY_POSITION: {
    PENDING: number;
    updatedAt: number;
  };
  SELL_POSITION: {
    PENDING: number;
    updatedAt: number;
  };
  TOPUP_DEPOSIT: {
    PENDING: number;
    updatedAt: number;
  };
  DEPOSIT: {
    PENDING: number;
    updatedAt: number;
  };
  ALMOST_EXPIRED_POSITIONS: {
    PENDING: number;
    updatedAt: number;
  };
};
